import { BoxContainer, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import { useMeetingSelector } from "@kalyzee/kast-web-sdk";
import React from "react";
import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";
import { MeetingShareContent } from "../common/MeetingShareContent";
import workBoxStyles from "./WorkBox.module.css";

export interface ShareWorkBoxProps {
  onClose?: () => void;
}

export const ShareWorkBox: React.FC<ShareWorkBoxProps> = ({ onClose }) => {
  const { containerAPI } = useMeetingContainerContext();
  const [shortId] = useMeetingSelector(containerAPI, "meeting", meeting => meeting?.shortId);

  const right: React.ReactNode[] = [];
  if (onClose) {
    right.push(
      <PrimaryButton key="close" onClick={onClose}>
        <ReactIcons.Close style={{ height: "0.8em" }} />
      </PrimaryButton>
    );
  }

  return (
    <BoxContainer
      style={{ width: "100%", height: "100%" }}
      topBarProps={{
        left: [<ReactIcons.QRCode key="qr-icon" style={{ width: "1.5em", height: "1.5em" }} />],
        center: [<span key="title" className={workBoxStyles.label}>Partager le meeting</span>],
        right,
      }}
    >
      <MeetingShareContent shortId={shortId} />
    </BoxContainer>
  );
};
